import {
    apiRequest,
    templateSuratCreate
} from "../../../../../services/adapters/master/templateSuratService.jsx"

class CreateRepository {

    fetchCreate = async (query) => {
        return await apiRequest("post", templateSuratCreate, {
            body: query
        }, true)
    }

}

export default CreateRepository
